import type { ReferralEnabled } from "@warrenio/api-spec/spec.oats.gen";

export const referralEnabledExample: ReferralEnabled = {
    enabled: true,
};
